import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { CadernoService } from "src/app/services/caderno.service";
import { obterConteudoCadernoPorId, obterConteudoCadernoPorIdFailure, obterConteudoCadernoPorIdSuccess } from "../../actions/Caderno/obter-conteudo-caderno-por-id.action";

@Injectable()
export class ObterConteudoCadernoPorIdEffects {
 
  public obterConteudoCadernoPorId$: unknown;

  constructor(private actions$: Actions,
    private cadernoService: CadernoService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterConteudoCadernoPorId$ = createEffect(() => this.actions$.pipe(
      ofType(obterConteudoCadernoPorId),
      switchMap(({ inputDto }) =>
        this.cadernoService
          .ObterConteudoCadernoPorId(inputDto)
          .pipe(
            map(
              response => {
                if (response.erros != undefined && response.erros.length > 0) {
                  return obterConteudoCadernoPorIdFailure({ response })
                }
                return obterConteudoCadernoPorIdSuccess({ response })
              }),
            catchError(() => {
              return of()
            }
            )
          )
      )
    )
    );
  }
}